import Alpine from 'alpinejs'

Alpine.store('session', {

    authenticated: false,
    bidReady: false,
    buyNowEnabled: false,
    hasBidBefore: false,
    token: null,
    uuid: null,

    setState(authenticated, bidReady, hasBidBefore, buyNowEnabled, token, uuid) {
        this.authenticated = authenticated
        this.bidReady = bidReady
        this.hasBidBefore = hasBidBefore
        this.buyNowEnabled = buyNowEnabled
        this.token = token
        this.uuid = uuid
    },

    async updateState(origin=null) {
        let url = '/bidagent/app/session'
        if(origin) {
            url += '?origin='+origin
        }
        return fetch(url, { method: 'POST', credentials: 'include' })
            .then(response => {
                if(!response.ok) {
                    throw new Error('response status '+response.status+'/'+response.statusText)
                }
                return response.json()
            }).then(state => {
                this.setState(
                    state.authenticated,
                    state.bidReady,
                    state.hasBidBefore,
                    state.buyNowEnabled,
                    state.token,
                    state.uuid
                )
            }).catch(error => {
                console.log(error)
            })
    },

    async login(username, password, autoLogin) {

        await this.updateState('session-store-login')
        if(this.authenticated) {
            return
        }

        const formData = new FormData()
        formData.append('username', username)
        formData.append('password', password)
        formData.append('form_key', this.token)
        if(autoLogin) {
            formData.append('auto', '1')
        }

        return fetch('/bidagent/app/login', {
            credentials: 'include',
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(formData)
        }).then(response => {
            if(!response.ok) {
                throw new Error('response status '+response.status+'/'+response.statusText)
            }
            return response.json()
        }).then(state => {
            if(!state.error) {
                this.setState(
                    state.authenticated,
                    state.bidReady,
                    state.hasBidBefore,
                    state.token,
                    state.uuid
                )
            }
        }).catch(error => console.log(error))
    }
})